<template>
  <div>
    <Gift @update="getListData"></Gift>
    <Card shadow>
      <Form :label-width="80">
        <Row :gutter="16">
          <Col span="4">
            <FormItem label="代理">
              <Select v-model="formData.app_id" placeholder="选择代理">
                <Option
                  v-for="(item, index) in app_list.filter(
                    item => item.platform == getinitPlatId()
                  )"
                  :value="item.appid"
                  :label="item.appName"
                  :key="index"
                >
                  {{ item.appName
                  }}<span style="color: #bbb">({{ item.appid }})</span>
                </Option>
              </Select>
            </FormItem>
          </Col>

          <Col span="4">
            <FormItem label="子商户号">
              <Input
                v-model="formData.pack_no"
                placeholder="请输入子商户号"
                clearable
              ></Input>
            </FormItem>
          </Col>

          <Col span="4">
            <FormItem label="玩家ID">
              <Input
                v-model="formData.user_id"
                placeholder="请输入玩家ID"
                clearable
              ></Input>
            </FormItem>
          </Col>

          <Col span="5">
            <FormItem label="时间范围">
              <DatePicker
                :clearable="false"
                style="width:100%;"
                type="daterange"
                :options="dateOptions"
                placeholder="筛选时间"
                separator=" ~ "
                v-model="formData.dataTime"
              ></DatePicker>
            </FormItem>
          </Col>

          <Col span="4">
            <Button
              type="primary"
              style="margin-right:10px"
              @click="getListData"
              >搜索</Button
            >
            <Button style="margin-right:10px" @click="resetData">重置</Button>
          </Col>
          <Col span="3" class="serach_right">
            <span>系统赠送</span>
            <span>{{ table.sumMoney }}</span>
          </Col>
        </Row>
      </Form>
    </Card>

    <Table
      border
      style="margin-top:12px;"
      :columns="table.colums"
      :data="table.data"
      ref="tableRef"
      :max-height="tableMaxHeight"
    ></Table>

    <Page
      style="margin-top:10px;"
      :total="page.total"
      show-total
      :current="page.currentPage"
      :page-size-opts="page.pageSizes"
      :page-size="page.pagesize"
      show-sizer
      @on-page-size-change="pageSizeChange"
      @on-change="pageChange"
    ></Page>
  </div>
</template>

<script>
import moment from 'moment'
import transToReq from '@/api/trans'
import Gift from './gift.vue'

export default {
  name: 'changePoint',
  components: {
    Gift
  },
  data() {
    return {
      tableMaxHeight: 0,
      select: {},
      formData: {
        app_id: '',
        pack_no: '',
        user_id: '',
        dataTime: [new Date(), new Date()]
      },
      table: {
        data: [],
        colums: [
          {
            key: 'order_no',
            title: '订单号',
            align: 'center',
            resizable: true
          },
          {
            key: 'user_id',
            title: '玩家ID',
            align: 'center',
            resizable: true
          },
          {
            key: 'pack_name',
            title: '子商户信息',
            align: 'center',
            resizable: true
          },
          {
            key: 'name',
            title: '玩家昵称',
            align: 'center',
            resizable: true
          },
          {
            key: 'old_point',
            title: '赠送前余额',
            align: 'center',
            resizable: true
          },
          {
            key: 'point',
            title: '赠送金额',
            align: 'center',
            resizable: true
          },
          {
            key: 'new_point',
            title: '赠送后余额',
            align: 'center',
            resizable: true
          },
          {
            key: 'status',
            title: '支付状态',
            align: 'center',
            resizable: true,
            render: (h, params) => {
              const statusMap = {
                '1': '未支付',
                '2': '已支付',
                '3': '退单',
                '99': '异常'
              }
              return h(
                'span',
                {
                  style: {
                    color: '#ccc'
                  }
                },
                statusMap[params.row.status]
              )
            }
          },
          {
            key: 'update_time',
            title: '完成时间',
            align: 'center',
            resizable: true
          },
          {
            key: 'pay_desc',
            title: '充值备注',
            align: 'center',
            resizable: true
          },
          {
            key: 'source_opt',
            title: '操作人ID',
            align: 'center',
            resizable: true
          }
        ],
        sumMoney: 0
      },
      page: {
        total: 0,
        totalSum: 0,
        pagesize: 15,
        pageSizes: [15, 30, 45, 60],
        currentPage: 1
      }
    }
  },
  methods: {
    // 获取数据
    getData() {
      const stime = moment(this.formData.dataTime[0])
        .startOf('day')
        .unix()
      const etime = moment(this.formData.dataTime[1])
        .endOf('day')
        .unix()
      const params = {
        stime,
        etime,
        page: this.page.currentPage,
        limit: this.page.pagesize,
        app_id: Number(this.formData.app_id),
        status: 0,
        sort: 0,
        pack_no: this.formData.pack_no ? Number(this.formData.pack_no) : -1,
        user_id: this.formData.user_id ? Number(this.formData.user_id) : 0
      }
      return transToReq('GivePayList', params)
    },
    // 获取列表数据
    async getListData() {
      try {
        const res = await this.getData()
        const data = res._param

        this.page.total = data.total
        this.table.sumMoney = data.sum
        if (data.data) {
          this.table.data = data.data
        }
      } catch (error) {
        console.log(error)
      }
    },
    pageChange(page) {
      this.page.currentPage = page
      this.getListData()
    },
    pageSizeChange(size) {
      this.page.pagesize = size
      this.getListData()
    },
    // 重置数据
    resetData() {
      this.formData = {
        pack_no: '',
        user_id: '',
        dataTime: [new Date(), new Date()]
      }
    }
  },
  activated() {
    this.formData.app_id = this.app_list.find(
      el => el.platform == Number(localStorage.getItem('platId'))
    )['appid']
    // 初始化列表数据
    this.getListData()
  },
  mounted() {
    this.tableMaxHeight = window.document.body.clientHeight - 390
  }
}
</script>
<style scoped lang="less">
.serach_right {
  span {
    padding: 8px 10px;
    display: inline-block;
    border: 1px solid #ddd;
  }
}
</style>
